import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";
import { css } from "styled-components";

/* Custom Code */
import { autocompleteProps } from "@store/Themes/common/props/autocomplete";
/* Custom Code */

interface Props {
    content: AutocompleteItemModel[] | null;
    focusedItem?: AutocompleteItemModel;
    goToUrl: (url: string) => void;
    extendedStyles?: AutocompleteContentStyles;
}

export interface AutocompleteContentStyles {
    headerText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
}

export const autocompleteContentStyles: AutocompleteContentStyles = {
    headerText: autocompleteProps.headerText,
    link: autocompleteProps.link,
    focusedLink: autocompleteProps.focusedLink,
};

const styles = autocompleteContentStyles;

class AutocompleteContent extends React.Component<Props> {
    private readonly styles: AutocompleteContentStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
    }

    render() {
        const { content } = this.props;
        if (!content || content.length === 0) {
            return null;
        }

        const styles = this.styles;
        return (
            <>
                <Typography
                    {...styles.headerText}
                    data-test-selector="autocompleteContent_Header"
                    className="autocomplete-content-header"
                >
                    {translate("Content")}
                </Typography>
                {/* Custom Code */}
                <ul>
                    {content.map(content => (
                        <li key={content.url}>
                            <Link
                                {...(this.props.focusedItem === content ? styles.focusedLink : styles.link)}
                                onClick={() => {
                                    this.props.goToUrl(content.url);
                                }}
                                data-test-selector="autocompleteContent_Result"
                                className="autocomplete-content-link"
                            >
                                {content.displayTitle}
                            </Link>
                        </li>
                    ))}
                </ul>
                {/* Custom Code */}
            </>
        );
    }
}

export default AutocompleteContent;
